export default "__VITE_ASSET__DhMoHF3x__"